import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { StoreContext, store, storeReady } from './app/stores/store';
import 'react-loading-skeleton/dist/skeleton.css';
import i18n from './i18n';
import { theme } from './app/styles/themes';
import { routes } from './Router';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

export const router = createBrowserRouter(routes);

const renderApp = () => {
  root.render(
    <StoreContext.Provider value={store}>
      <I18nextProvider i18n={i18n}>
        <ThemeProvider theme={theme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </I18nextProvider>
    </StoreContext.Provider>
  );
};

const bootstrap = async () => {
  await storeReady;
  renderApp();
};

bootstrap().catch((error) => {
  console.error('Failed to initialize stores before app bootstrap.', error);
  renderApp();
});
